import { makeAutoObservable } from 'mobx'

import { Collection } from './Collection'

import type TemplateModel from './TemplateModel'
import { GOF, SectionUiStyle, GOFGroupConfigType } from '../types'
import { UnionFieldModelType } from '../types/Field'
import { GOFCategory } from '../constants'

class GOFModel {
   readonly gofId: string
   name: string | null | undefined
   description: string | null | undefined

   fieldsCollection: Collection<string, UnionFieldModelType>
   orderedFieldIds: string[]
   gofCategory: GOFCategory | undefined
   template: TemplateModel
   enableAddAnother: boolean | undefined
   addAnotherGofResponsesLimit?: number | null
   sectionUiStyle: SectionUiStyle | undefined
   groups?: GOFGroupConfigType[]

   constructor(gof: GOF, template: TemplateModel) {
      this.gofId = gof.gofId
      this.name = gof.name
      this.description = gof.description
      this.gofCategory = gof.gofCategory
      this.orderedFieldIds = gof.orderedFieldIds
      this.template = template
      this.enableAddAnother = gof.enableAddAnother
      this.sectionUiStyle = gof.sectionUiStyle
      this.groups = gof.groups
      this.addAnotherGofResponsesLimit = gof.addAnotherGofResponsesLimit
      this.fieldsCollection = new Collection<string, UnionFieldModelType>(
         'The field you are trying to access does not exist.'
      )

      makeAutoObservable(this)
   }

   get fields(): UnionFieldModelType[] {
      return this.fieldsCollection.orderedItems
   }

   getFieldSelectorFieldIdsForDependentField = (fieldId: string): string[] => {
      const field = this.fieldsCollection.getItem(fieldId)
      if (!field.isDependent)
         throw new Error(`field: ${fieldId} is not dependent field`)

      const dependentOnFieldIds: string[] = []
      this.fields.forEach(field => {
         if (field.fieldType === 'FIELDS_SELECTOR') {
            if (field.allDependentFieldIds.includes(fieldId)) {
               dependentOnFieldIds.push(field.fieldId)
            }
         }
      })
      return dependentOnFieldIds
   }

   setOrderedFieldIds = (orderedFieldIds: string[]): void => {
      this.orderedFieldIds = orderedFieldIds
   }
}

export default GOFModel
